@if (value(); as value) {
  {{ value | onyxLanguage }}
} @else {
  -
}
